import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { environment } from '../../environments/environment';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap'; // Angular Bootstrap - https://ng-bootstrap.github.io

import { AppRoutingElsModule } from './app-routing.module';
import { AppComponent } from '../shared/app.component';
import { ElsComponent } from './els.component';
import { SettingsService } from '../shared/settings/settings.service';
import { AuthGuard } from '../shared/auth-guard.service';
import { AuthService } from '../shared/auth.service';
import { UtilsService } from '../shared/utils/utils.service';
import { SharedModule } from '../shared/shared.module';
import { MapServicesService } from '../shared/services/map-services.service';
import { HomeComponent } from './home/home.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { LicenceComponent } from './licence/licence.component';
import { LicenceContentComponent } from './licence/components/licence-content/licence-content.component';
import { HighlightSearch } from '../shared/utils/highlightPipe';
import { AccessDataComponent } from './access-data/access-data.component';
import { AccessibilityComponent } from './accessibility/accessibility.component';
import { DatasetsComponent } from './datasets/datasets.component';
import { DatasetsService } from './datasets/datasets.service';
import { ExploreMapComponent } from './explore-map/explore-map.component';
import { LegendComponent } from './explore-map/components/legend/legend.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { LicenceModalComponent } from './access-data/components/licence-modal/licence-modal.component';
import { PrivacyModalComponent } from './access-data/components/privacy-modal/privacy-modal.component';
import { DatasetCoverageMapComponent } from './datasets/components/dataset-coverage-map/dataset-coverage-map.component';
import { DatasetsListComponent } from './explore-map/components/datasets-list/datasets-list.component';
import { GazetteerSearchComponent } from './explore-map/components/gazetteer-search/gazetteer-search.component';
import { IdentifyFeatureComponent } from './explore-map/components/identify-feature/identify-feature.component';
import { FrequentlyAskedQuestionsComponent } from './frequently-asked-questions/frequently-asked-questions.component';
import { BackToTopComponent } from './footer/components/back-to-top/back-to-top.component';
import { PrivacyContentComponent } from './privacy-policy/components/privacy-content/privacy-content.component';
import { ExploreMapService } from './explore-map/explore-map.service';
import { AttributionsComponent } from './attributions/attributions.component';
import { IdentifyErrorModalComponent } from './explore-map/components/identify-error-modal/identify-error-modal.component';
import { DatasetsAtLocationErrorModalComponent } from './explore-map/components/datasets-at-location-error-modal/datasets-at-location-error-modal.component';
import { CadastralLayerPanelComponent } from './explore-map/components/cadastral-layer-panel/cadastral-layer-panel.component';
import { GazetteerLayerPanelComponent } from './explore-map/components/gazetteer-layer-panel/gazetteer-layer-panel.component';
import { HvlspLayerPanelComponent } from './explore-map/components/hvlsp-layer-panel/hvlsp-layer-panel.component';
import { TagInputModule } from "ngx-chips";
import { BytesConverterPipe } from "../shared/utils/bytes-converter.pipe";

/**
 * This is the entrypoint for the Eurogeographics ELS portal.  ELS specific components are defined within this module.
 * Common components to all whitelabel sites are defined in the SharedModule
 */
@NgModule({
  declarations: [
    ElsComponent,
    HomeComponent,
    TermsConditionsComponent,
    AboutComponent,
    ContactComponent,
    PrivacyPolicyComponent,
    AccessDataComponent,
    AccessibilityComponent,
    DatasetsComponent,
    ExploreMapComponent,
    LegendComponent,
    FooterComponent,
    HeaderComponent,
    IdentifyErrorModalComponent,
    DatasetsAtLocationErrorModalComponent,
    LicenceModalComponent,
    LicenceComponent,
    LicenceContentComponent,
    PrivacyModalComponent,
    DatasetCoverageMapComponent,
    DatasetsListComponent,
    GazetteerSearchComponent,
    IdentifyFeatureComponent,
    FrequentlyAskedQuestionsComponent,
    BackToTopComponent,
    PrivacyContentComponent,
    AttributionsComponent,
    CadastralLayerPanelComponent,
    GazetteerLayerPanelComponent,
    HvlspLayerPanelComponent,
    BytesConverterPipe,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgbModule,
    AppRoutingElsModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule, // Contains custom common components
    TagInputModule,
  ],
  exports: [HighlightSearch],
  providers: [
    SettingsService,
    AuthGuard,
    AuthService,
    UtilsService,
    MapServicesService,
    DatasetsService,
    ExploreMapService,
    Title,
  ],
  bootstrap: [AppComponent], // Custom shared component that launches app
  entryComponents: [
    LicenceModalComponent,
    PrivacyModalComponent,
    IdentifyErrorModalComponent,
    DatasetsAtLocationErrorModalComponent,
  ],
})
export class AppModule {}
